import { useTranslation } from 'react-i18next';
import { Navigate, useParams } from 'react-router-dom';

import { PageSeo } from '../components/PageSeo';
import { SubpageLayout } from '../components/SubpageLayout';
import { getMemberSectionBySlug } from '../data/memberAreaContent';
import { truncateMetaDescription } from '../utils/metaText';

/**
 * Üyelere özel içerik sayfaları — URL: /member-area/:section
 */
export function MemberSectionPage() {
    const { t } = useTranslation();
    const { section } = useParams();
    const meta = getMemberSectionBySlug(section);

    if (!meta) {
        return <Navigate to="/panel" replace />;
    }

    const description =
        truncateMetaDescription(meta.placeholderBody) ||
        t('seo.defaultDescription');

    return (
        <>
            <PageSeo
                title={`${meta.title} — ${t('header.rotaryAlt')}`}
                description={description}
                noindex
            />
            <SubpageLayout
                title={meta.title}
                subtitle={meta.subtitle}
                contentClassName="member-area-page"
            >
                <div className="member-area-placeholder">
                    <p className="member-area-placeholder-text mb-0">
                        {meta.placeholderBody}
                    </p>
                </div>
            </SubpageLayout>
        </>
    );
}
